import { render, staticRenderFns } from "./RejectList.vue?vue&type=template&id=6df1b27f&scoped=true"
import script from "./RejectList.vue?vue&type=script&lang=js"
export * from "./RejectList.vue?vue&type=script&lang=js"
import style0 from "./RejectList.vue?vue&type=style&index=0&id=6df1b27f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df1b27f",
  null
  
)

export default component.exports